const countries = [
  {
    id: 'AF',
    label: 'Afghanistan',
  },
  {
    id: 'AL',
    label: 'Albania',
  },
  {
    id: 'DZ',
    label: 'Algeria',
  },
  {
    id: 'AD',
    label: 'Andorra',
  },
  {
    id: 'AO',
    label: 'Angola',
  },
  {
    id: 'AR',
    label: 'Argentina',
  },
  {
    id: 'AM',
    label: 'Armenia',
  },
  {
    id: 'AW',
    label: 'Aruba',
  },
  {
    id: 'AU',
    label: 'Australia',
  },
  {
    id: 'AT',
    label: 'Austria',
  },
  {
    id: 'AZ',
    label: 'Azerbaijan',
  },
  {
    id: 'BH',
    label: 'Bahrain',
  },
  {
    id: 'BD',
    label: 'Bangladesh',
  },
  {
    id: 'BY',
    label: 'Belarus',
  },
  {
    id: 'BE',
    label: 'Belgium',
  },
  {
    id: 'BZ',
    label: 'Belize',
  },
  {
    id: 'BJ',
    label: 'Benin',
  },
  {
    id: 'BT',
    label: 'Bhutan',
  },
  {
    id: 'BO',
    label: 'Bolivia',
  },
  {
    id: 'BA',
    label: 'Bosnia And Herzegovina',
  },
  {
    id: 'BW',
    label: 'Botswana',
  },
  {
    id: 'BR',
    label: 'Brazil',
  },
  {
    id: 'IO',
    label: 'British Indian Ocean Territory',
  },
  {
    id: 'BN',
    label: 'Brunei Darussalam',
  },
  {
    id: 'BG',
    label: 'Bulgaria',
  },
  {
    id: 'BF',
    label: 'Burkina Faso',
  },
  {
    id: 'BI',
    label: 'Burundi',
  },
  {
    id: 'KH',
    label: 'Cambodia',
  },
  {
    id: 'CM',
    label: 'Cameroon',
  },
  {
    id: 'CV',
    label: 'Cape Verde',
  },
  {
    id: 'CF',
    label: 'Central African Republic',
  },
  {
    id: 'TD',
    label: 'Chad',
  },
  {
    id: 'CL',
    label: 'Chile',
  },
  {
    id: 'CN',
    label: 'China',
  },
  {
    id: 'CO',
    label: 'Colombia',
  },
  {
    id: 'KM',
    label: 'Comoros',
  },
  {
    id: 'CG',
    label: 'Congo',
  },
  {
    id: 'CD',
    label: 'Congo, Democratic Republic',
  },
  {
    id: 'CK',
    label: 'Cook Islands',
  },
  {
    id: 'CR',
    label: 'Costa Rica',
  },
  {
    id: 'CI',
    label: "Cote D'Ivoire",
  },
  {
    id: 'HR',
    label: 'Croatia',
  },
  {
    id: 'CU',
    label: 'Cuba',
  },
  {
    id: 'CY',
    label: 'Cyprus',
  },
  {
    id: 'CZ',
    label: 'Czech Republic',
  },
  {
    id: 'DK',
    label: 'Denmark',
  },
  {
    id: 'DJ',
    label: 'Djibouti',
  },
  {
    id: 'EC',
    label: 'Ecuador',
  },
  {
    id: 'EG',
    label: 'Egypt',
  },
  {
    id: 'SV',
    label: 'El Salvador',
  },
  {
    id: 'GQ',
    label: 'Equatorial Guinea',
  },
  {
    id: 'ER',
    label: 'Eritrea',
  },
  {
    id: 'EE',
    label: 'Estonia',
  },
  {
    id: 'ET',
    label: 'Ethiopia',
  },
  {
    id: 'FK',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    id: 'FO',
    label: 'Faroe Islands',
  },
  {
    id: 'FJ',
    label: 'Fiji',
  },
  {
    id: 'FI',
    label: 'Finland',
  },
  {
    id: 'FR',
    label: 'France',
  },
  {
    id: 'PF',
    label: 'French Polynesia',
  },
  {
    id: 'GA',
    label: 'Gabon',
  },
  {
    id: 'GM',
    label: 'Gambia',
  },
  {
    id: 'GE',
    label: 'Georgia',
  },
  {
    id: 'DE',
    label: 'Germany',
  },
  {
    id: 'GH',
    label: 'Ghana',
  },
  {
    id: 'GI',
    label: 'Gibraltar',
  },
  {
    id: 'GR',
    label: 'Greece',
  },
  {
    id: 'GL',
    label: 'Greenland',
  },
  {
    id: 'GT',
    label: 'Guatemala',
  },
  {
    id: 'GN',
    label: 'Guinea',
  },
  {
    id: 'GW',
    label: 'Guinea-Bissau',
  },
  {
    id: 'GY',
    label: 'Guyana',
  },
  {
    id: 'HT',
    label: 'Haiti',
  },
  {
    id: 'HN',
    label: 'Honduras',
  },
  {
    id: 'HK',
    label: 'Hong Kong',
  },
  {
    id: 'HU',
    label: 'Hungary',
  },
  {
    id: 'IS',
    label: 'Iceland',
  },
  {
    id: 'IN',
    label: 'India',
  },
  {
    id: 'ID',
    label: 'Indonesia',
  },
  {
    id: 'IR',
    label: 'Iran, Islamic Republic Of',
  },
  {
    id: 'IQ',
    label: 'Iraq',
  },
  {
    id: 'IE',
    label: 'Ireland',
  },
  {
    id: 'IL',
    label: 'Israel',
  },
  {
    id: 'IT',
    label: 'Italy',
  },
  {
    id: 'JP',
    label: 'Japan',
  },
  {
    id: 'JO',
    label: 'Jordan',
  },
  {
    id: 'KP',
    label: 'KP',
  },
  {
    id: 'KE',
    label: 'Kenya',
  },
  {
    id: 'KI',
    label: 'Kiribati',
  },
  {
    id: 'KR',
    label: 'Korea',
  },
  {
    id: 'KW',
    label: 'Kuwait',
  },
  {
    id: 'KG',
    label: 'Kyrgyzstan',
  },
  {
    id: 'LA',
    label: "Lao People's Democratic Republic",
  },
  {
    id: 'LV',
    label: 'Latvia',
  },
  {
    id: 'LB',
    label: 'Lebanon',
  },
  {
    id: 'LS',
    label: 'Lesotho',
  },
  {
    id: 'LR',
    label: 'Liberia',
  },
  {
    id: 'LY',
    label: 'Libyan Arab Jamahiriya',
  },
  {
    id: 'LI',
    label: 'Liechtenstein',
  },
  {
    id: 'LT',
    label: 'Lithuania',
  },
  {
    id: 'LU',
    label: 'Luxembourg',
  },
  {
    id: 'MO',
    label: 'Macao',
  },
  {
    id: 'MK',
    label: 'Macedonia',
  },
  {
    id: 'MG',
    label: 'Madagascar',
  },
  {
    id: 'MW',
    label: 'Malawi',
  },
  {
    id: 'MY',
    label: 'Malaysia',
  },
  {
    id: 'MV',
    label: 'Maldives',
  },
  {
    id: 'ML',
    label: 'Mali',
  },
  {
    id: 'MT',
    label: 'Malta',
  },
  {
    id: 'MH',
    label: 'Marshall Islands',
  },
  {
    id: 'MR',
    label: 'Mauritania',
  },
  {
    id: 'MU',
    label: 'Mauritius',
  },
  {
    id: 'MX',
    label: 'Mexico',
  },
  {
    id: 'FM',
    label: 'Micronesia, Federated States Of',
  },
  {
    id: 'MD',
    label: 'Moldova',
  },
  {
    id: 'MC',
    label: 'Monaco',
  },
  {
    id: 'MN',
    label: 'Mongolia',
  },
  {
    id: 'ME',
    label: 'Montenegro',
  },
  {
    id: 'MA',
    label: 'Morocco',
  },
  {
    id: 'MZ',
    label: 'Mozambique',
  },
  {
    id: 'NA',
    label: 'Namibia',
  },
  {
    id: 'NP',
    label: 'Nepal',
  },
  {
    id: 'NL',
    label: 'Netherlands',
  },
  {
    id: 'NC',
    label: 'New Caledonia',
  },
  {
    id: 'NZ',
    label: 'New Zealand',
  },
  {
    id: 'NI',
    label: 'Nicaragua',
  },
  {
    id: 'NE',
    label: 'Niger',
  },
  {
    id: 'NG',
    label: 'Nigeria',
  },
  {
    id: 'NU',
    label: 'Niue',
  },
  {
    id: 'NF',
    label: 'Norfolk Island',
  },
  {
    id: 'NO',
    label: 'Norway',
  },
  {
    id: 'OM',
    label: 'Oman',
  },
  {
    id: 'PK',
    label: 'Pakistan',
  },
  {
    id: 'PA',
    label: 'Panama',
  },
  {
    id: 'PG',
    label: 'Papua New Guinea',
  },
  {
    id: 'PY',
    label: 'Paraguay',
  },
  {
    id: 'PE',
    label: 'Peru',
  },
  {
    id: 'PH',
    label: 'Philippines',
  },
  {
    id: 'PL',
    label: 'Poland',
  },
  {
    id: 'PT',
    label: 'Portugal',
  },
  {
    id: 'QA',
    label: 'Qatar',
  },
  {
    id: 'RO',
    label: 'Romania',
  },
  {
    id: 'RU',
    label: 'Russian Federation',
  },
  {
    id: 'RW',
    label: 'Rwanda',
  },
  {
    id: 'WS',
    label: 'Samoa',
  },
  {
    id: 'SM',
    label: 'San Marino',
  },
  {
    id: 'ST',
    label: 'Sao Tome And Principe',
  },
  {
    id: 'SA',
    label: 'Saudi Arabia',
  },
  {
    id: 'SN',
    label: 'Senegal',
  },
  {
    id: 'RS',
    label: 'Serbia',
  },
  {
    id: 'SC',
    label: 'Seychelles',
  },
  {
    id: 'SL',
    label: 'Sierra Leone',
  },
  {
    id: 'SG',
    label: 'Singapore',
  },
  {
    id: 'SK',
    label: 'Slovakia',
  },
  {
    id: 'SI',
    label: 'Slovenia',
  },
  {
    id: 'SB',
    label: 'Solomon Islands',
  },
  {
    id: 'SO',
    label: 'Somalia',
  },
  {
    id: 'ZA',
    label: 'South Africa',
  },
  {
    id: 'ES',
    label: 'Spain',
  },
  {
    id: 'LK',
    label: 'Sri Lanka',
  },
  {
    id: 'SD',
    label: 'Sudan',
  },
  {
    id: 'SR',
    label: 'Suriname',
  },
  {
    id: 'SZ',
    label: 'Swaziland',
  },
  {
    id: 'SE',
    label: 'Sweden',
  },
  {
    id: 'CH',
    label: 'Switzerland',
  },
  {
    id: 'SY',
    label: 'Syrian Arab Republic',
  },
  {
    id: 'TW',
    label: 'Taiwan',
  },
  {
    id: 'TJ',
    label: 'Tajikistan',
  },
  {
    id: 'TZ',
    label: 'Tanzania',
  },
  {
    id: 'TH',
    label: 'Thailand',
  },
  {
    id: 'TL',
    label: 'Timor-Leste',
  },
  {
    id: 'TG',
    label: 'Togo',
  },
  {
    id: 'TK',
    label: 'Tokelau',
  },
  {
    id: 'TO',
    label: 'Tonga',
  },
  {
    id: 'TN',
    label: 'Tunisia',
  },
  {
    id: 'TR',
    label: 'Turkey',
  },
  {
    id: 'TM',
    label: 'Turkmenistan',
  },
  {
    id: 'TV',
    label: 'Tuvalu',
  },
  {
    id: 'UG',
    label: 'Uganda',
  },
  {
    id: 'UA',
    label: 'Ukraine',
  },
  {
    id: 'AE',
    label: 'United Arab Emirates',
  },
  {
    id: 'GB',
    label: 'United Kingdom',
  },
  {
    id: 'US',
    label: 'United States',
  },
  {
    id: 'UY',
    label: 'Uruguay',
  },
  {
    id: 'VU',
    label: 'Vanuatu',
  },
  {
    id: 'VE',
    label: 'Venezuela',
  },
  {
    id: 'VN',
    label: 'Viet Nam',
  },
  {
    id: 'WF',
    label: 'Wallis And Futuna',
  },
  {
    id: 'YE',
    label: 'Yemen',
  },
  {
    id: 'ZM',
    label: 'Zambia',
  },
  {
    id: 'ZW',
    label: 'Zimbabwe',
  },
];

export default countries;
